<template>
  <div>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <div v-if="!isLoading">
      <v-row>
        <v-col>
          <span class="text-tcdc-green bold header text-uppercase">e-book</span>
        </v-col>
      </v-row>
      <v-row class="mb-4">
        <v-col cols="12" sm="6" md="6" :class="{'pr-4': $vuetify.breakpoint.smAndUp}">
          <EbookImageCard :image="ebook.cover_img_path" />
        </v-col>
        <v-col
                cols="12"
                sm="6"
                md="6"
                :class="{'pl-4': $vuetify.breakpoint.smAndUp}"
                class="d-flex flex-1 flex-column"
        >
          <p class="text-tcdc-green header bold">{{ebook[`subject_${lang}`]}}</p>
          <p
                  class="vhtml bold"
                  v-html="ebook[`intro_${lang}`]"
          ></p>
          <!-- <div class="d-flex"> -->
          <div class="mb-4">
            <span class="mr-4 text-tcdc-grey1 bold">{{ebook.article_date | moment('DD MMM YYYY')}}</span>
            <img src="../../assets/icons/generals/download.png" class="tcdc-download-icon mr-2" />
            <span class="text-tcdc-grey1 bold">{{formatNumber(ebook.count_download)}}</span>
          </div>
          <!-- </div> -->
          <v-row>
            <v-col cols="12" md="8" class="d-flex flex-column">
              <GreenButton
                      width="250px"
                      label="desktop version"
                      class="mb-4"
                      v-if="ebook[`file_path_desktop_${lang}`]"
                      @onPress="downloadEbook(ebook[`file_path_desktop_${lang}`])"
              />
              <GreenButton
                      width="250px"
                      label="mobile/tablet version"
                      class="mb-6"
                      v-if="ebook[`file_path_mobile_${lang}`]"
                      @onPress="downloadEbook(ebook[`file_path_mobile_${lang}`])"
              />
              <ShareButton mode="ebook"></ShareButton>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mb-12">
        <v-col>
        <span class="vhtml" v-html="ebook[`detail_${lang}`]">
        </span>
        </v-col>
      </v-row>
      <!--    <v-row>-->
      <!--      <v-col class="pb-0">-->
      <!--        <span class="text-tcdc-green bold sub-header1 text-uppercase">related e-book</span>-->
      <!--      </v-col>-->
      <!--    </v-row>-->
      <!--    <v-row>-->
      <!--      <template v-for="item of 3">-->
      <!--        <v-col cols="12" sm="6" md="4" :key="item.toString()">-->
      <!--          <EbookCard :border="false" />-->
      <!--        </v-col>-->
      <!--      </template>-->
      <!--    </v-row>-->
    </div>
  </div>
</template>

<script>
import EbookImageCard from "../../components/cards/EbookImageCard";
import GreenButton from "../../components/buttons/GreenButton";
import EbookCard from "../../components/cards/EbookCard";
import ShareButton from "../../components/buttons/ShareButton";
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';

export default {
  components: {
    EbookImageCard,
    GreenButton,
    // EbookCard,
    ShareButton,
    Loading
  },
  async created() {
    this.items[0].text = this.branchName;
    this.isLoading = true;
    await this.$store.dispatch('Article/onGetArticleById', { id: this.$route.params.id, lang: this.lang });
    this.isLoading = false;
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      lang: state => state.Branch.lang,
      ebook: state => state.Article.article
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    }
  },
  methods: {
    formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    downloadEbook(path) {
      if (path) {
        window.open(path);
      }
    }
  },
  data: () => ({
    isLoading: false,
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home"
      },
      {
        text: "SERVICE",
        disabled: false,
        href: "/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/service/resource-center"
      },
      {
        text: "E-BOOK",
        href: "/service/resource-center/e-book"
      }
    ]
  })
};
</script>

<style>
</style>
